import { Chip, styled } from '@material-ui/core';

export const ModifiersContainer = styled('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: 8,
  alignItems: 'center',
  overflow: 'hidden',
  width: '100%',
  minWidth: 0,
});

export const ModifierChip = styled(Chip)({
  flexShrink: 0,
});

export const ModifierChipEllipsis = styled(Chip)({
  flexShrink: 1,
  minWidth: 0,
  maxWidth: '100%',
  '& .MuiChip-label': {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});
